var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-buttons mb-4"},[_c('b-button',{staticClass:"action-button mr-2",attrs:{"variant":"danger","to":_vm.cleanRouteString(_vm.route)}},[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }